import { render, staticRenderFns } from "./STableInventoriesComp.vue?vue&type=template&id=620961f0&"
import script from "./STableInventoriesComp.vue?vue&type=script&lang=js&"
export * from "./STableInventoriesComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports